<div class="container">
  <app-loading [loadingText]="'Cargando ' + appName"></app-loading>
  <div class="environment-badge" *ngIf="isDevelopment">
    <p-tag value="Development" severity="contrast" class="environment-tag" />
  </div>
</div>
